
module.exports = {
  direction: "ltr",
  breakpoints: require("./breakpoints.json"),
  zIndices: require("./zIndexes.json"),
  radii: require("./radii.json"),
  blur: require("./blur.json"),
  colors: require("./colors.json"),
  letterSpacings: require("./letterSpacings.json"),
  lineHeights: require("./lineHeights.json"),
  fontWeights: require("./typography/fontWeights.json"),
  fonts: require("./typography/fonts.json"),
  fontSizes: require("./typography/fontSizes.json"),
  sizes: require("./sizes.json"),
  shadows: require("./shadows.json"),
  space: require("./space.json"),
  borders: require("./borders.json"),
  transition: require("./transition.json"),
  components: require("./components"),
  styles: {},
  config: require("./config.json"),
}
